/* TF Set Picker v1.1 (Tires Fast). Loaded by blocks/tf-set-picker.liquid.
   Drives the Horizon product form's own quantity input and Add to cart label. */
(function () {
  if (window.tfSetPickerLoaded) return;
  window.tfSetPickerLoaded = true;

  function findForm() {
    return document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
  }
  function findQty(form) {
    return form ? form.querySelector('input[name="quantity"]') : null;
  }
  function findButton(form) {
    return form ? form.querySelector('.add-to-cart-button, button[type="submit"][name="add"], button[type="submit"]') : null;
  }
  function textNodes(el, out) {
    out = out || [];
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) out.push(n);
      else if (n.nodeType === 1 && n.tagName !== 'SVG' && n.tagName !== 'svg') textNodes(n, out);
    }
    return out;
  }

  function init(root) {
    if (!root || root.dataset.tfInit === '1') return;
    root.dataset.tfInit = '1';
    var setQty = parseInt(root.dataset.setQty, 10) || 4;
    var singleLabel = root.dataset.singleLabel || 'Add to cart';
    var setLabel = root.dataset.setLabel || 'Add set of 4 to cart';
    var radios = root.querySelectorAll('input[type="radio"]');
    var cards = root.querySelectorAll('[data-tf-picker-card]');
    var syncing = false;

    function setQuantity(q) {
      var form = findForm();
      var input = findQty(form);
      if (!input) return;
      if (parseInt(input.value, 10) === q) return;
      syncing = true;
      input.value = q;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('blur', { bubbles: true }));
      syncing = false;
    }

    function setLabelText(mode) {
      var btn = findButton(findForm());
      if (!btn) return;
      var nodes = textNodes(btn);
      var want = mode === 'set' ? setLabel : singleLabel;
      var other = mode === 'set' ? singleLabel : setLabel;
      for (var i = 0; i < nodes.length; i++) {
        var t = nodes[i].nodeValue.trim();
        if (t === other || t === singleLabel || t === setLabel) {
          nodes[i].nodeValue = nodes[i].nodeValue.replace(t, want);
          return;
        }
      }
    }

    function paint(mode) {
      root.dataset.mode = mode;
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.toggle('is-selected', cards[i].dataset.tfPickerCard === mode);
      }
    }

    function apply(mode, fromQty) {
      paint(mode);
      setLabelText(mode);
      if (!fromQty) setQuantity(mode === 'set' ? setQty : 1);
    }

    for (var r = 0; r < radios.length; r++) {
      radios[r].addEventListener('change', function (e) {
        if (e.target.checked) apply(e.target.value, false);
      });
    }

    // Keep the cards honest if the shopper edits the quantity field directly.
    var form = findForm();
    var qtyInput = findQty(form);
    if (qtyInput) {
      var onQty = function () {
        if (syncing) return;
        var q = parseInt(qtyInput.value, 10) || 1;
        var mode = q === setQty ? 'set' : 'single';
        for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === mode;
        apply(mode, true);
      };
      qtyInput.addEventListener('change', onQty);
      qtyInput.addEventListener('input', onQty);
      if (form) form.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.quantity-plus, .quantity-minus')) setTimeout(onQty, 0);
      });
    }

    var checked = root.querySelector('input[type="radio"]:checked');
    apply(checked ? checked.value : (root.dataset.default || 'set'), false);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-tf-picker]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', initAll);
})();